import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ExternalInstrumentsEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";

interface OwnerData {
    ID: string;
    gDisp_1: string;
}
class ExternalInstrumentsEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private inputOwner: MdsLax<InstanceType<typeof HintBox>>;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let cowner = this.getAttributeValue("cowner");
        let owner = this.getAttributeValue("ref_owner");

        if (cowner && !owner) {
            this.inputOwner.setValue(cowner, true);
        }
    }

    private _onChangeInputOwner(value) {
        //
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ExternalInstrument;
    }

    private _onClick_OpenSED(identifierName, evt) {

        this.loadSelectEntityDialog(evt,
            identifierName,
            lang.hitch(this, this._onCallback_Dlg)
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<any>>) {
        // fake-entity falls das zur�ckgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;

        switch (mode) {
            case "selectInstrumentOwner":

                let entity = {
                    ID: items[0].entry.value, gDisp_1: items[0].entry.label
                }

                this.inputOwner.setValue(entity)
                break;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputOwner.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectInstrumentOwner"));
        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ExternalInstrumentsEditor);